import HomepagePrefecture from "features/Prefecture";
import { useParams } from "react-router-dom";

export default function PrefecturePage() {
  const { prefecture } = useParams();

  return <HomepagePrefecture prefecture={prefecture ?? ""} />;
}
